<template>
    <span id="hamburger-button" @click="responsiveOpenNav()">
        <iconHamburgerButton class="d-block" />
    </span>
</template>

<script>
import iconHamburgerButton from '@/assets/img/account/header/hamburger-button.svg?inline';
import { LudumEventBus } from '@/event-bus';

export default {
    components: {
        iconHamburgerButton
    },

    props: ['event'],

    methods: {
        responsiveOpenNav() {
            LudumEventBus.$emit(this.event);
        }
    }
};
</script>
